
<template>
  <div>
    <v-btn
      depressed
      @click="$refs.searchFilter.openModal()"
      class="border-1"
    >
      <v-icon>mdi-plus</v-icon>
      <span class="ml-2 d-none d-md-flex">New Loan</span>
    </v-btn>
    
    <!-- Account Lookup filter modal -->
    <AccountLookupModal
      @searchDetails="showResults"
      ref="searchFilter"
    />

    <!-- Search results modal -->
    <AccountSearchResults
      @goBack="$refs.searchFilter.openModal($event)"
      ref="searchResults"
    />
  </div>
</template>

<script>
import AccountLookupModal from '@/modules/loanpro/components/loan-pro/Search/AccountLookupModal.vue';
import AccountSearchResults from '@/modules/loanpro/components/loan-pro/Search/AccountSearchResults.vue';
export default {
  components: { AccountLookupModal, AccountSearchResults },
  methods: {
    showResults(searchDetails) {
      // open results modal
      this.$refs.searchResults.openModal(searchDetails);
    },
  }
};
</script>

